import type { RawParams } from '@wix/tpa-router';

import { EGroupPartition } from '@wix/social-groups-serverless/dist/groups/types';

import type { StateDeclarationFn } from 'controller/types';
import { ELayoutType } from 'settings/constants';

import settingsParams from '../settingsParams';

export default (function (vm, store, params) {
  const { settings } = params.flowAPI;
  const { isMobile } = params.flowAPI.environment;

  return {
    name: 'groups.list',
    url: `?partition&{title:URIEncoded}&sort`,
    data: { sectionId: 'groups' },
    params: {
      partition: {
        squash: true,
        value: EGroupPartition.ALL,
      },
      sort: {
        squash: true,
        value: settings.get(settingsParams.sortBy),
      },
    },
    resolve: [
      {
        token: 'groups',
        deps: ['$stateParams', 'layout'],
        async resolveFn(params: RawParams, layout: ELayoutType) {
          switch (layout) {
            case ELayoutType.List:
              return vm.groups$.query({
                ...params,
                limit: 6,
                namespace: params.partition,
                partition: params.partition,
              });

            case ELayoutType.Grid:
              return vm.groups$.query({
                ...params,
                limit: 6,
                namespace: params.partition,
                partition: params.partition,
              });

            case ELayoutType.Sidebar:
            default:
              return isMobile
                ? Promise.resolve([])
                : Promise.all([
                    vm.groups$.query({
                      limit: 5,
                      sort: params.sort,
                      namespace: EGroupPartition.JOINED,
                      partition: EGroupPartition.JOINED,
                    }),
                    vm.groups$.query({
                      limit: 10,
                      sort: params.sort,
                      namespace: EGroupPartition.SUGGESTED,
                      partition: EGroupPartition.SUGGESTED,
                    }),
                  ]);
          }
        },
      },
    ],
  };
} as StateDeclarationFn);
